import { useEffect } from "react";

const usePreventBackNavigation = (isOverlayOpen) => {
	useEffect(() => {
		if (!isOverlayOpen) {
			return () => {};
		}

		const handleBeforeUnload = (event) => {
			event.preventDefault();
			event.returnValue = "";
			return "";
		};

		const handlePopState = () => {
			window.history.pushState(null, "", window.location.href);
		};

		window.history.pushState(null, "", window.location.href);

		window.addEventListener("beforeunload", handleBeforeUnload);
		window.addEventListener("popstate", handlePopState);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
			window.removeEventListener("popstate", handlePopState);
		};
	}, [isOverlayOpen]);
};

export default usePreventBackNavigation;
